{
  "es": {
    "paintBooth": {
      "paints": "Pinturas",
      "empty": "Elige una nave para ver sus pinturas.",
      "unavailable": "No se pudo cargar el holo pintado de esta nave.",
      "notFound": "No se encontró esta nave."
    }
  }
}
